import 'hammerjs';
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { akitaConfig, persistState, enableAkitaProdMode } from '@datorama/akita';
import { debounceTime } from 'rxjs/operators';
import 'hammerjs';

akitaConfig({
  resettable: true
});

if (environment.production) {
  enableProdMode();
  enableAkitaProdMode();
  if (window) {
    window.console.log = function () { };
  }
}

persistState({
  exclude: ['router'],
  preStorageUpdateOperator: () => debounceTime(500),
  storage: sessionStorage,
  key: 'MO:Admin'
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
